import { createContext } from 'react';

const ViewerContext = createContext(undefined);

export default ViewerContext;
